import { Link } from 'react-router-dom';
import { getHotComics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function HotRecommend() {
  const hotComics = getHotComics(8);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            热门推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-1">
            最受读者欢迎的韩国漫画精选
          </p>
        </div>
        <Link
          to="/category/romance"
          className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          查看更多
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5" data-product-shop>
        {hotComics.map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>
    </section>
  );
}